<template>
  <div id="time-picker">
    <input
      type="time"
      class="time-input"
      name="input"
      v-model="localTime"
      required
    />
    <b-form-timepicker
      v-model="localTime"
      :locale="$i18n.locale"
      id="picker-button"
      class="picker-button border-0"
      button-only
    ></b-form-timepicker>
  </div>
</template>

<script>
export default {
  name: 'HMTimePicker',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      localTime: null,
    };
  },
  methods: {},
  watch: {
    value: {
      handler: function (value) {
        this.localTime = value;
      },
      immediate: true,
    },
    localTime: function (val) {
      const splitTime = val.split(':');
      const finalTime = `${splitTime[0]}:${splitTime[1]}`;
      console.log('selectedTime=', finalTime);
      this.$emit('input', finalTime);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

#time-picker {
  display: flex;
  border: 1px solid $medium-gray;
  border-right: none;
  border-radius: $border-radius;

  input[type='time']::-webkit-calendar-picker-indicator {
    background: none;
    display: none;
  }
  .time-input {
    width: 100%;
    border: none;
    outline: none;
    border-radius: $border-radius;
    padding-left: 0.5rem;
    &.focus-visible {
      outline: none;
    }
  }
  ::v-deep button#picker-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: $border-radius;
    border-bottom-right-radius: $border-radius;
    background-color: $light-gray;
    border-top: none;
    border-bottom: none;
  }
}
</style>
